/* Amaurine — storefront behaviour */
(function () {
  /* ── §adtraffic (7 Sep 2026) ─────────────────────────────────────────────────────────────
     Is this session an ad click, or a Facebook/Instagram/TikTok in-app browser? Two dialogues
     in front of a product cost double in a webview (Clarity: 80% of sessions), so the promotion
     modal and the Klaviyo pop-up both ask this before they do anything.

     THREE SIGNALS, any one of which is enough:
       · a click id in the URL — fbclid, gclid, ttclid
       · utm_source naming a social platform. `ig` is matched as a whole token only, so a
         utm_source of "digital" or "signal" is not mistaken for Instagram.
       · the user agent — FB_IAB / FBAN / FBAV (Facebook), Instagram, TikTok.

     STICKY FOR THE SESSION. The click id is on the landing URL and nowhere else, so without a
     flag the second page of an ad visit would look like organic traffic and the modal would
     open on it. A true answer is written to sessionStorage('hov_ad') and every later page reads
     it back. sessionStorage, not localStorage: the same person arriving organically next week
     is not ad traffic. Every storage call is wrapped — Safari private mode and locked-down
     browsers throw on read and on write — and a throw FAILS CLOSED here (treated as not-ad),
     which is the same behaviour the site had before this existed. */
  function hovAdTraffic() {
    try { if (window.sessionStorage.getItem('hov_ad') === '1') return true; } catch (e) {}
    var hit = false;
    try {
      var qs = new URLSearchParams(window.location.search);
      if (qs.get('fbclid') || qs.get('gclid') || qs.get('ttclid')) hit = true;
      var src = (qs.get('utm_source') || '').toLowerCase();
      if (/facebook|instagram|meta|tiktok/.test(src) || /(^|[^a-z])ig([^a-z]|$)/.test(src)) hit = true;
    } catch (e2) {}
    if (!hit && /FB_IAB|FBAN|FBAV|Instagram|TikTok/i.test(navigator.userAgent || '')) hit = true;
    if (hit) { try { window.sessionStorage.setItem('hov_ad', '1'); } catch (e3) {} }
    return hit;
  }
  window.hovAdTraffic = hovAdTraffic;

  /* ── §klaviyo — REMOVED 22 Sep 2026 ──
     From 7 Sep this block injected klaviyo.js from window.hovKlaviyoSrc (set by layout/theme.liquid
     off the product/cart templates) unless hovAdTraffic() — so ad and in-app visitors, and every
     product page, never loaded it, and "Active on Site" in Klaviyo read 0. The Klaviyo Shopify app
     is now installed with its onsite app embed ON, which writes the <script async> tag on every
     template itself; this copy only double-loaded the file for organic home/collection visits.
     hovAdTraffic() stays — §promodal still asks it. */

  // ── PDP gallery: thumbnail switches the main image ──
  // 6 Sep 2026 — video-aware. A product whose first media is a video renders that video in the
  // main slot server-side (templates/product.liquid, snippets/hov-video.liquid) so it plays with
  // JS off; any video thumb swaps the SAME single <video> node in, and an image thumb pauses and
  // hides it again. On a product with no video none of this can fire: there is no [data-video]
  // thumb, hovVid stays null, and every line below is the code that was here before.
  var main = document.getElementById('pdp-main');
  var thumbs = document.getElementById('pdp-thumbs');
  var mainSlot = document.querySelector('.gal .main');
  var zoomBtnEl = document.getElementById('pdp-zoom-open');
  var hovVid = document.getElementById('pdp-mainvid');
  var hovReduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // ── §video ──
  // prefers-reduced-motion: CSS cannot pause a video, so the autoplay attribute is stripped and
  // the element paused here. The poster is already painted, so the frame stays — no empty box.
  // Runs over every autoplaying video on the page, which covers the sets-page tiles too.
  if (hovReduce.matches) {
    document.querySelectorAll('video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.autoplay = false;
      try { v.pause(); } catch (err) {}
    });
  }

  // ── §slots ──
  // VIDEO SLOTS, 6 Sep 2026 (owner: "a named slot on every page I drop a file into"). Two
  // attributes, both written by snippets/hov-video.liquid and by nothing else:
  //
  //   data-hov-media="<css media query>"  — a desktop/phone pair (the homepage hero, 16:9 and
  //     9:16). The element whose query does NOT match is removed from the DOM outright, so the
  //     browser never fetches the file it was never going to show. CSS hides it too, which is
  //     what covers the JS-off case. Evaluated once, at load, on purpose: re-adding a removed
  //     <video> on a resize would start a fresh download mid-scroll, and a phone does not turn
  //     into a desktop.
  //
  //   data-hov-lazy — everything below the fold (house cards, sets band, brand film, collection
  //     hero). Rendered with preload="none" and no autoplay attribute, so not one byte of video
  //     is fetched until the element comes within 300px of the viewport. It is paused again when
  //     it leaves, so a homepage with four films is never decoding one that nobody can see. A
  //     .collhero is display:none below 768px and therefore never intersects — which is exactly
  //     the behaviour wanted there, and why that slot is lazy rather than eager.
  //
  // Reduced motion: a lazy video is never started at all, so the poster frame is the whole
  // download. The eager slots are stripped and paused by §video above.
  (function () {
    document.querySelectorAll('video[data-hov-media]').forEach(function (v) {
      var q = v.getAttribute('data-hov-media');
      if (!q) return;
      var mq;
      try { mq = window.matchMedia(q); } catch (err) { return; }
      if (mq.matches) return;
      try { v.pause(); } catch (err2) {}
      v.remove();
    });

    var lazies = document.querySelectorAll('video[data-hov-lazy]');
    if (!lazies.length) return;
    // 18 Sep 2026 (image-perf pass): the collection and homepage hero pairs are lazy slots now
    // too (sections/am-collection.liquid, templates/index.liquid — see the note in
    // snippets/hov-video.liquid). A hero intersects immediately, so two more rules:
    //   1. Nothing plays before the page's `load` event (or 3 s, whichever is first). Every
    //      image in the first viewport is done by then, so the film no longer races the tiles
    //      for the connection — the measured failure on David's phone.
    //   2. Save-Data, or a connection the browser itself calls 2g/3g, keeps the poster and
    //      never starts a film (Android Chrome exposes this; iOS does not, and simply plays).
    // Below-the-fold slots are unaffected in practice: by the time they scroll in, load has fired.
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    var slotSkip = !!(conn && (conn.saveData || /(^|-)[23]g$/.test(conn.effectiveType || '')));
    // 18 Sep 2026, evening (Lighthouse mobile on live, brand/amaurine/TAP-FIX-2026-09-18.md): with
    // "load OR 3 s" the film still opened at the same tick as `load` on a fast trace, and on a
    // slow phone the 3 s fallback fires long before `load`, so the 6 MB film was still racing the
    // tiles and was still the LCP element (its poster paints as the video's first frame).
    // PHONES — no hover, or ≤767px — now wait for ALL of:
    //   a. the page's `load` event (or a 12 s ceiling, so a third-party script that never settles
    //      cannot keep the poster on screen for ever),
    //   b. every eager first-row tile image (`.card .shot[loading="eager"]`) being complete,
    //   c. an idle main thread (requestIdleCallback, 1.5 s timeout),
    //   d. the element within 300px of the viewport (the IntersectionObserver below).
    // Save-Data / 2g / 3g still never start a film. DESKTOP is byte-for-byte the 18 Sep afternoon
    // behaviour: `load` or 3 s, whichever first. The phone poster is a separate <picture> in
    // sections/am-collection.liquid (the phone <video> carries no poster) so an <img>, not the
    // video, is the LCP element; `playing` below fades it out.
    // 28 Sep 2026 (audit H3, David "fix it"; brand/amaurine/audit-2026-09-28/PAGE-FIXES-SHIPPED.md):
    // the phone rules (a)–(d) above now apply on EVERY width — "collection films load after the
    // grid on all widths" — so a desktop no longer starts a 6 MB film at the 3 s mark while its
    // first tile row is still arriving. The eager list also includes the homepage hero's poster
    // (.am-hero-poster, templates/index.liquid). And a lazy <video> may now ship with NO <source>
    // at all: the file URL sits in data-hov-src and slotPlay() attaches it here, the first time the
    // element is both armed (load + eager images + idle) and on screen — so not one byte of the
    // film is requested before the page has painted what the visitor came for.
    var slotTiles = Array.prototype.slice.call(document.querySelectorAll('.card .shot[loading="eager"], .am-hero-poster'));
    var slotLoaded = document.readyState === 'complete';
    var slotCeiling = false;
    var slotScheduled = false;
    var slotReady = false;
    var slotQueue = [];
    var slotPlay = function (v) {
      if (slotSkip) return;
      if (hovReduce.matches) return;
      var src = v.getAttribute('data-hov-src');
      if (src && !v.querySelector('source')) {
        var s = document.createElement('source');
        s.src = src;
        s.type = 'video/mp4';
        v.appendChild(s);
        try { v.load(); } catch (err0) {}
      }
      if (v.getAttribute('preload') !== 'metadata') v.setAttribute('preload', 'metadata');
      var p;
      try { p = v.play(); } catch (err) { return; }
      if (p && p.catch) p.catch(function () {});
    };
    var slotFlush = function () {
      slotReady = true;
      slotQueue.splice(0).forEach(slotPlay);
    };
    var slotTilesDone = function () {
      for (var i = 0; i < slotTiles.length; i++) { if (!slotTiles[i].complete) return false; }
      return true;
    };
    var slotArm = function () {
      if (slotScheduled) return;
      if (!slotLoaded && !slotCeiling) return;
      if (!slotTilesDone()) return;
      slotScheduled = true;
      if (window.requestIdleCallback) window.requestIdleCallback(slotFlush, { timeout: 1500 });
      else slotFlush();
    };
    if (!slotLoaded) window.addEventListener('load', function () { slotLoaded = true; slotArm(); });
    window.setTimeout(function () { slotCeiling = true; slotArm(); }, 12000);
    slotTiles.forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', slotArm);
      img.addEventListener('error', slotArm);
    });
    slotArm();
    var slotStart = function (v) {
      if (slotReady) slotPlay(v);
      else if (slotQueue.indexOf(v) < 0) slotQueue.push(v);
    };
    lazies.forEach(function (v) {
      v.addEventListener('playing', function () {
        // 28 Sep 2026: the homepage hero figure (.am-hero-fig) fades its poster the same way
        var fig = v.closest ? v.closest('.am-film, .am-hero-fig') : null;
        if (fig) fig.classList.add('is-playing');
      });
    });
    if (!('IntersectionObserver' in window)) {
      lazies.forEach(slotStart);
      return;
    }
    var slotIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) slotStart(en.target);
        else {
          var qi = slotQueue.indexOf(en.target);
          if (qi > -1) slotQueue.splice(qi, 1);
          try { en.target.pause(); } catch (err) {}
        }
      });
    }, { rootMargin: '300px 0px' });
    lazies.forEach(function (v) { slotIO.observe(v); });
  })();

  function hovVideoShow(btn) {
    if (!mainSlot) return;
    if (!hovVid) {
      // no server-rendered video (the video is not this product's first media) — build one once
      var v = document.createElement('video');
      v.id = 'pdp-mainvid';
      v.className = 'mainvid';
      v.muted = true;
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('muted', '');
      v.setAttribute('loop', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'metadata');
      v.setAttribute('width', '1400');
      v.setAttribute('height', '1750');
      mainSlot.insertBefore(v, mainSlot.firstChild);
      hovVid = v;
    }
    var id = btn.getAttribute('data-media-id') || btn.getAttribute('data-video') || '';
    if (hovVid.getAttribute('data-media-id') !== id) {
      hovVid.setAttribute('data-media-id', id);
      var poster = btn.getAttribute('data-poster');
      if (poster) hovVid.setAttribute('poster', poster);
      hovVid.setAttribute('aria-label', btn.getAttribute('aria-label') || 'Product video');
      while (hovVid.firstChild) hovVid.removeChild(hovVid.firstChild);
      var src = btn.getAttribute('data-video');
      if (src) {
        var s = document.createElement('source');
        s.src = src;
        s.type = btn.getAttribute('data-video-type') || 'video/mp4';
        hovVid.appendChild(s);
        hovVid.load();
      }
    }
    hovVid.hidden = false;
    // the zoom trigger wraps the main <img>: hiding it hides both, and takes the zoom button
    // out of the tab order while there is nothing to zoom.
    if (zoomBtnEl) zoomBtnEl.hidden = true;
    if (!hovReduce.matches) {
      var pr = hovVid.play();
      if (pr && pr.catch) pr.catch(function () {}); // autoplay policy — poster stays, no error
    }
  }
  function hovVideoHide() {
    if (hovVid) {
      try { hovVid.pause(); } catch (err) {}
      hovVid.hidden = true;
    }
    if (zoomBtnEl) zoomBtnEl.hidden = false;
  }

  if (thumbs) {
    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      if (btn.hasAttribute('data-video')) {
        hovVideoShow(btn);
        thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
        btn.classList.add('on');
        return;
      }
      if (!main) return;
      var full = btn.getAttribute('data-full');
      if (!full) return;
      // 3 Sep 2026: the main image carries a srcset now, so swap that too — a bare src
      // change is ignored by the browser while a srcset is present.
      var ss = btn.getAttribute('data-srcset');
      if (ss) main.setAttribute('srcset', ss); else main.removeAttribute('srcset');
      main.src = full;
      hovVideoHide();
      thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
      btn.classList.add('on');
    });
  }

  // ── scroll reveals ──
  var io;
  function observe() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
      return;
    }
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el, i) {
      el.style.transitionDelay = (i % 4) * 130 + 'ms';
      io.observe(el);
    });
  }
  observe();

  // ── sticky add-to-bag bar (mobile PDP, 12 Aug 2026) ──
  // Reveals once the purchase form has scrolled up out of view; hides again when the buyer
  // scrolls back to it. A rAF-throttled scroll check rather than IntersectionObserver: an
  // instant scroll jump (deep link, restored position) can skip an element entirely without
  // its intersection ratio ever crossing a threshold, leaving an IO-driven bar stuck.
  // Fixed position — zero layout shift either way.
  // 3 Sep 2026 rework: the target is the Add-to-bag BUTTON, not the form, and "out of view"
  // is measured against the sticky header's bottom edge (the button is hidden behind it well
  // before it reaches y=0) and against the bar's own height at the bottom (so the bar is gone
  // by the time the button scrolls up under it). Both directions count: a tall gallery can
  // leave the button below the fold on load, and the bar should offer the purchase then too.
  var buyForm = document.getElementById('pdp-form');
  var atcBar = document.getElementById('atc-bar');
  if (buyForm && atcBar) {
    var buyBtn = buyForm.querySelector('button[name="add"]') || buyForm;
    var siteHdr = document.querySelector('header');
    var atcTick = false;
    var atcUpdate = function () {
      atcTick = false;
      var r = buyBtn.getBoundingClientRect();
      var top = siteHdr ? siteHdr.getBoundingClientRect().bottom : 0;
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var barH = atcBar.offsetHeight || 0;
      // 14 Sep 2026: bar appears on scroll, in-flow button visible; data-always removed (overlap
      // at load). `away` = the in-flow Add to bag has genuinely left the viewport (above the
      // header, or wholly below the fold). The old `vh - barH` cushion was self-triggering: on a
      // 390x844 PDP the button lands inside the bar's own strip at scroll 0, so the bar switched
      // itself on at first paint and covered the Afterpay line and the trust strip.
      // 18 Sep 2026 night (FLOW-PASS-2026-09-18.md, fix 5): `away` also when the button is CUT
      // by the fold. Measured on live at 390x844 the ring's in-flow Add to bag sat at 822–874 —
      // 22px showing, the bar off — and with the wayfinding strip above the book every PDP's
      // button starts below the fold. The bar covers the strip of page the button was peeking
      // from, so there is never a half button under a whole one; it slides away the moment the
      // in-flow button is fully on screen.
      var away = r.bottom <= top || r.bottom > vh;
      atcBar.classList.toggle('on', away);
      atcBar.setAttribute('aria-hidden', away ? 'false' : 'true');
      // 3 Sep 2026 (b): the Klaviyo teaser reads these to lift itself clear of the bar (hov.css)
      document.body.classList.toggle('atc-on', away);
      document.documentElement.style.setProperty('--atc-h', barH + 'px');
    };
    var atcQueue = function () {
      if (!atcTick) { atcTick = true; requestAnimationFrame(atcUpdate); }
    };
    window.addEventListener('scroll', atcQueue, { passive: true });
    window.addEventListener('resize', atcQueue);
    window.addEventListener('load', atcQueue);
    atcUpdate();
  }

  // ── PDP size selector (29 Aug 2026) ──
  // The rings carry a Size option the template never surfaced: every buyer silently received
  // the first size, and orders auto-fulfil with no human check between bag and dispatch. So:
  // no default. The radios (name="id", inside #pdp-form) post the variant themselves; both
  // add-to-bag buttons render disabled as "Select a size" and only an explicit, in-stock pick
  // enables them, mirrors the id into the sticky bar's hidden input (the two forms can never
  // disagree), refreshes price/reference, and writes ?variant= into the URL via replaceState
  // (no history spam) so a shared link or back/forward re-renders preselected server-side.
  var sizeBox = document.getElementById('pdp-sizes');
  var sizeDataEl = document.getElementById('pdp-size-data');
  if (sizeBox && sizeDataEl && buyForm) {
    var sizes = JSON.parse(sizeDataEl.textContent);
    var addBtn = buyForm.querySelector('button[name="add"]');
    var barForm = document.getElementById('atc-bar-form');
    var barBtn = barForm && barForm.querySelector('button[name="add"]');
    var barId = barForm && barForm.querySelector('input[name="id"]');
    var priceEl = document.getElementById('pdp-price-amt') || document.querySelector('.info .price');
    var barPr = document.querySelector('.atc-pr');
    var skuEl = document.getElementById('pdp-sku');
    // 4 Sep 2026: the Afterpay line follows the size the same way the price does. The sentence
    // is pre-built per variant by snippets/hov-afterpay.liquid (see #pdp-size-data `ap`), so
    // this does no money maths and no eligibility maths — an empty string IS "not eligible".
    // Absent when the gate is shut, which is the current live state.
    var apayEl = document.getElementById('pdp-afterpay');
    // 18 Sep 2026 night (FLOW-PASS-2026-09-18.md, fix 5): "Select a size" is a live prompt, not a
    // dead button. The template still ships both buttons `disabled` (the no-JS guard: a form with
    // no checked radio must never post). With JS, `disabled` comes off and aria-disabled +
    // .is-unsized go on; a tap on either button — the sticky bar's included, which is the one a
    // phone buyer sees first — scrolls the size row to just under the header and pulses the
    // pills once. Both submit guards below still refuse a sizeless post, so nothing can be added.
    var sizeHdr = document.querySelector('header');
    var setUnsized = function (on) {
      [addBtn, barBtn].forEach(function (b) {
        if (!b) return;
        if (on) { b.disabled = false; b.setAttribute('aria-disabled', 'true'); b.classList.add('is-unsized'); }
        else { b.removeAttribute('aria-disabled'); b.classList.remove('is-unsized'); }
      });
    };
    var nudgeSizes = function () {
      var y = sizeBox.getBoundingClientRect().top + (window.pageYOffset || 0)
              - ((sizeHdr ? sizeHdr.getBoundingClientRect().height : 0) + 24);
      try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); } catch (scErr) { window.scrollTo(0, Math.max(0, y)); }
      sizeBox.classList.remove('is-nudged');
      void sizeBox.offsetWidth;
      sizeBox.classList.add('is-nudged');
      window.setTimeout(function () { sizeBox.classList.remove('is-nudged'); }, 1600);
    };
    [addBtn, barBtn].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function (e) {
        if (b.getAttribute('aria-disabled') !== 'true') return;
        e.preventDefault();
        nudgeSizes();
      });
    });
    var applySize = function (id, fromLoad) {
      var v = null;
      sizes.forEach(function (s) { if (s.id === id) v = s; });
      if (!v || !v.available) return; // disabled radios can't fire this, but never trust it
      setUnsized(false);
      [addBtn, barBtn].forEach(function (b) {
        if (b) { b.disabled = false; b.textContent = 'Add to bag'; }
      });
      if (barId) barId.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (barPr) barPr.textContent = v.price;
      if (skuEl && v.sku) skuEl.textContent = v.sku;
      if (apayEl) {
        apayEl.textContent = v.ap || '';
        apayEl.hidden = !v.ap;
      }
      if (!fromLoad) {
        try { history.replaceState(null, '', location.pathname + '?variant=' + v.id); }
        catch (hsErr) { /* sandboxed viewers — the pick itself still works */ }
      }
    };
    sizeBox.addEventListener('change', function (e) {
      if (e.target.name === 'id') applySize(parseInt(e.target.value, 10), false);
    });
    // a ?variant= deep link (or a bfcache restore) arrives with its radio already checked
    var preSize = sizeBox.querySelector('input[name="id"]:checked');
    if (preSize && !preSize.disabled) applySize(parseInt(preSize.value, 10), true);
    else {
      // phones and tablets only (the header's own breakpoint): desktop keeps the disabled button
      // exactly as it was — the size pills sit beside it there, nothing to scroll to.
      var sizeSmall = false;
      try { sizeSmall = window.matchMedia('(max-width: 1023px)').matches; } catch (mqErr) {}
      if (sizeSmall) setUnsized(true);
    }
    // belt-and-braces: never let either form post without an explicit size
    buyForm.addEventListener('submit', function (e) {
      if (!sizeBox.querySelector('input[name="id"]:checked')) e.preventDefault();
    });
    if (barForm) barForm.addEventListener('submit', function (e) {
      if (!barId || !barId.value) e.preventDefault();
    });
  }

  // ── add-a-set to bag (sets page, 12 Aug 2026) ──
  // Standard cart API multi-line add; the button only renders when every member is buyable.
  document.querySelectorAll('[data-set-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var items = btn.getAttribute('data-set-add').split(',').map(function (v) {
        return { id: parseInt(v, 10), quantity: 1 };
      });
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        // 3 Sep 2026 (M3): open the bag drawer where it exists; /cart stays the fallback
        if (window.hovBag) {
          btn.disabled = false;
          btn.textContent = 'Add the set to bag';
          window.hovBag.added(btn);
        } else {
          window.location.href = '/cart';
        }
      }).catch(function () {
        btn.disabled = false;
        btn.textContent = 'Add the set to bag';
      });
    });
  });

  // ── bag drawer (3 Sep 2026, M3) ──
  // Progressive enhancement over the two PDP forms (#pdp-form, #atc-bar-form): with JS the
  // submit becomes POST /cart/add.js, then /cart.js is rendered into the right-side drawer
  // (layout/theme.liquid §bag); without JS, or if the network call itself fails, the form
  // posts to /cart exactly as before. A 4xx from add.js (sold out, bad variant) is shown in
  // the drawer rather than re-posted — the native post would only reach the same error page.
  // Qty and remove go through /cart/change.js; the header count (.bag-n) updates live.
  // Focus: opening moves focus to Close, Tab is trapped inside, Esc/scrim/Close return focus
  // to the button that opened it. Motion honours prefers-reduced-motion (CSS side).
  var bagEl = document.getElementById('bag-drawer');
  var bagScrim = document.getElementById('bag-scrim');
  var bagCloseBtn = document.getElementById('bag-close');
  if (bagEl && bagScrim && bagCloseBtn && window.fetch && window.URLSearchParams) {
    var bagBody = document.getElementById('bagd-body');
    var bagCountEl = document.getElementById('bagd-count');
    // 7 Sep 2026: #bagd-fs and #bagd-fill are gone. Shipping is complimentary Australia-wide on
    // every order, permanently (owner decision 5A), so the drawer's shipping line is one static
    // sentence in layout/theme.liquid — server-rendered, on screen before this script runs —
    // and there is no threshold, no progress track and no "A$x away" branch left to maintain.
    // #bagd-gst is static for the same reason: nothing here is ever calculated at checkout.
    var bagSubEl = document.getElementById('bagd-sub');
    // the reassurance block (delivery, returns, welcome code, payment marks) — hidden on an
    // empty bag, where there is nothing to reassure anyone about
    var bagReassure = document.getElementById('bagd-reassure');
    // 4 Sep 2026: present only when Afterpay is live (snippets/hov-afterpay.liquid emits the
    // element behind the same gate as the PDP and cart lines). Wording and the funded range
    // both travel on the element, so the sentence has exactly one home in the theme.
    var bagApay = document.getElementById('bagd-apay');
    var apMin = bagApay ? parseInt(bagApay.getAttribute('data-ap-min'), 10) || 100 : 0;
    var apMax = bagApay ? parseInt(bagApay.getAttribute('data-ap-max'), 10) || 200000 : 0;
    var apTpl = bagApay ? (bagApay.getAttribute('data-ap-tpl') || '') : '';
    var bagErr = document.getElementById('bagd-err');
    // 5 Sep 2026: the automatic-discount rows (layout/theme.liquid §bag). Empty and hidden
    // until /cart.js actually reports a discount — see bagDiscounts() below.
    var bagDisc = document.getElementById('bagd-disc');
    var bagCheckout = document.getElementById('bagd-checkout');
    var moneyFmt = bagEl.getAttribute('data-money') || '${{amount}}';
    // 7 Sep 2026 — set membership. /cart.js reports `has_components: true` on a bundle parent
    // line but never lists the components (verified against the live cart API), and the cart
    // page's Liquid `item_components` has no equivalent here. The names therefore travel on the
    // drawer element, written once in layout/theme.liquid. A malformed or absent attribute
    // leaves an empty map and the drawer behaves exactly as it did before: one set line, no
    // parts — never an error.
    var bagSets = {};
    try { bagSets = JSON.parse(bagEl.getAttribute('data-sets') || '{}') || {}; }
    catch (setsErr) { bagSets = {}; }
    var bagLastFocus = null;
    var bagOpen = false;

    var esc = function (s) {
      return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    };
    // money: the shop's own format string ("${{amount}}" here), filled the way Liquid would
    var money = function (cents) {
      var n = (cents / 100).toFixed(2);
      var parts = n.split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/,/g, '.'))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, whole.replace(/,/g, '.') + ',' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
        .replace(/\{\{\s*amount\s*\}\}/g, whole + '.' + parts[1]);
    };
    // (the plain A$ helper that printed "A$x away from complimentary shipping" retired 7 Sep
    // 2026 with the threshold itself — see the note on the drawer elements above)
    // 7 Sep 2026: `?width=` instead of the `_200x` filename form. Two reasons — it is the
    // canonical Shopify CDN parameter and works on every URL shape the cart API can hand back,
    // and it is byte-for-byte the URL Liquid's `image_url: width: 200` produces, which is what
    // the PDP prefetch below warms. Same URL string = the drawer's photo comes out of cache
    // instead of leaving a dark square for ~1.1s at the exact moment of confirmation.
    var thumbUrl = function (url, w) {
      if (!url) return '';
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    };
    /* PDP thumbnail prefetch (7 Sep 2026, critique blocker 4.4). templates/product.liquid puts
       the piece's own featured image, already at width 200, on #pdp-form as data-thumb — the
       same URL thumbUrl() will build from the cart's image. Warmed at idle, so it costs nothing
       against the LCP hero and never competes with the gallery: by the time the buyer taps Add
       to bag the file is in cache and the drawer opens with the photo already there. Best-effort
       only — no prefetch means the old behaviour, not a failure. */
    (function () {
      var pdpF = document.getElementById('pdp-form');
      var pdpThumb = pdpF && pdpF.getAttribute('data-thumb');
      if (!pdpThumb) return;
      var warm = function () { var im = new Image(); im.src = pdpThumb; };
      if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 3000 });
      else window.setTimeout(warm, 1200);
    })();

    var setBagCount = function (n) {
      document.querySelectorAll('.bag-n').forEach(function (el) { el.textContent = n; });
    };
    var showErr = function (msg) {
      bagErr.textContent = msg;
      bagErr.hidden = !msg;
    };

    // ── automatic discounts in the drawer (5 Sep 2026) ──
    // A Shopify AUTOMATIC discount never appears on a product page or a tile — it is applied
    // to the cart — so without this the buyer's first sight of the saving was the checkout.
    // Deliberately GENERIC: no promotion name, no percentage, no date is hard-coded here. The
    // rows are built from whatever /cart.js reports, labelled with the discount's OWN title,
    // so the next promotion needs no change to this file and the current one disappears by
    // itself the moment Shopify stops applying it (including right now, if the discount has
    // not been created yet — `total_discount` is 0 and this returns an empty array).
    //
    // Where the money is. A "30% off these collections" automatic discount is allocated at the
    // LINE level, so it lands in items[].line_level_discount_allocations, not in
    // cart_level_discount_applications — both are read, plus items[].discounts as the legacy
    // fallback. cart.total_discount is the cart's own figure and always wins: if the breakdown
    // cannot be reconstructed, or the parts do not sum to it, one authoritative row is shown
    // instead of a number this script assembled. The buyer is never shown arithmetic of ours.
    //
    // 16 Sep 2026 (BUILD-LOG §29.7) — TWO BREAKDOWNS, TRIED IN ORDER, neither of them mixed.
    // The old version read the cart-level applications AND, on any line with no line-level
    // allocation, that line's legacy `discounts` array — but on a stacked cart the legacy array
    // carries the line's share of the CART-level discount too, so that share was counted twice
    // and the reconcile check then threw the whole breakdown away. Live proof, the 4-piece
    // Auréole bag of 16 Sep: cart-level "15% off the rest" 23205 + Rivière's legacy 9285 +
    // Comète's line-level 27900 = 60390 against a real total_discount of 51105, so the drawer
    // fell back to one nameless "Discount −$511.05" row while the cart page named both.
    //   Pass A — the allocations Shopify publishes, read exactly as templates/cart.liquid reads
    //            them: cart-level `total_allocated_amount`, then line-level allocations.
    //   Pass B — the legacy per-line `discounts` array ALONE, which carries both levels per line.
    // Whichever sums to cart.total_discount wins; if neither does, one authoritative row.
    var bagDiscounts = function (cart) {
      var totalDisc = parseInt(cart.total_discount, 10) || 0;
      if (totalDisc <= 0) return [];
      var titles = {}, nTitles = 0, lastTitle = '';
      var build = function (collect) {
        var rows = [], seen = {}, resolved = 0;
        collect(function (title, amount) {
          amount = parseInt(amount, 10) || 0;
          var key = String(title == null ? '' : title).trim() || 'Discount';
          if (titles[key] === undefined) { titles[key] = 1; nTitles++; lastTitle = key; }
          if (amount <= 0) return;
          if (seen[key] === undefined) { seen[key] = rows.length; rows.push({ title: key, amount: 0 }); }
          rows[seen[key]].amount += amount;
          resolved += amount;
        });
        return (rows.length && resolved === totalDisc) ? rows : null;
      };
      var byAllocation = build(function (push) {
        (cart.cart_level_discount_applications || []).forEach(function (d) {
          push(d.title || d.description, d.total_allocated_amount);
        });
        (cart.items || []).forEach(function (it) {
          (it.line_level_discount_allocations || []).forEach(function (a) {
            var app = a.discount_application || {};
            push(app.title || app.description, a.amount);
          });
        });
      });
      if (byAllocation) return byAllocation;
      var byLegacy = build(function (push) {
        (cart.items || []).forEach(function (it) {
          (it.discounts || []).forEach(function (d) { push(d.title || d.description, d.amount); });
        });
      });
      if (byLegacy) return byLegacy;
      return [{ title: nTitles === 1 ? lastTitle : 'Discount', amount: totalDisc }];
    };

    // 16 Sep 2026 (BUILD-LOG §29.7) — WHICH FIGURE IS THE LINE.
    // /cart.js publishes two line totals and they are NOT the same number on a stacked cart:
    //   `final_line_price`   — net of the LINE-level part only
    //   `line_price`         — net of EVERY discount, the cart-level "across" allocation included
    // and `line_price` is the same figure Liquid's `item.line_price` gives templates/cart.liquid,
    // which is why using it here makes the drawer and the page agree line for line. Live proof,
    // the same 4-piece bag: Rivière Ring original_line_price 61900, line_price 52615,
    // final_line_price 61900 — the drawer used to print $619.00 against the page's $526.15.
    // The subtraction is a documented fallback only, for a cart payload that omits `line_price`.
    var lineNet = function (it) {
      if (typeof it.line_price === 'number') return it.line_price;
      return (it.original_line_price || 0) - (parseInt(it.total_discount, 10) || 0);
    };

    var renderBag = function (cart) {
      var items = cart.items || [];
      setBagCount(cart.item_count);
      bagCountEl.textContent = cart.item_count ? '· ' + cart.item_count + (cart.item_count === 1 ? ' piece' : ' pieces') : '';
      var total = cart.total_price || 0;
      // THE LEDGER (16 Sep 2026, BUILD-LOG §29.7 — mirrors templates/cart.liquid §29.5).
      // `cart.total_price` has always been net of every discount, so the Subtotal below IS the
      // discounted subtotal. What this block adds is the working above it: an **Original** row,
      // then **one row per discount carrying its own allocated amount**, so the column the buyer
      // reads actually adds up — Original − discounts = Subtotal — and the struck-through line
      // prices beside each piece are explained rather than silently deducted a second time.
      // Gated on a real discount existing: with none, no Original row and no rows, exactly as
      // before. `original_total_price` is the cart's own figure, not one assembled here.
      var linesReconcile = false;
      if (items.length) {
        var netSum = 0;
        items.forEach(function (it) { netSum += lineNet(it); });
        linesReconcile = netSum === total;
      }
      if (bagDisc) {
        var discRows = items.length ? bagDiscounts(cart) : [];
        if (discRows.length) {
          bagDisc.innerHTML =
            '<div class="bagd-sub bagd-orig"><span class="lab">Original</span>' +
              '<span class="amt">' + money(cart.original_total_price) + '</span></div>' +
            discRows.map(function (d) {
              return '<div class="bagd-sub"><span class="lab">' + esc(d.title) + '</span>' +
                '<span class="amt">−' + money(d.amount) + '</span></div>';
            }).join('');
          bagDisc.hidden = false;
        } else {
          bagDisc.innerHTML = '';
          bagDisc.hidden = true;
        }
      }
      bagSubEl.textContent = money(total);
      if (bagReassure) bagReassure.hidden = !items.length;
      if (bagApay) {
        var apShow = items.length > 0 && total >= apMin && total <= apMax;
        bagApay.textContent = apShow ? apTpl.replace('{amount}', money(Math.round(total / 4))) : '';
        bagApay.hidden = !apShow;
      }
      if (!items.length) {
        bagBody.innerHTML = '<div class="bagd-empty"><p>Your bag is empty.</p>' +
          '<a href="/collections/gold">Browse Gold</a>' +
          '<a href="/collections/silver">Browse Silver</a></div>';
        bagCheckout.setAttribute('aria-disabled', 'true');
        bagCheckout.setAttribute('tabindex', '-1');
        bagCheckout.style.opacity = '.42';
        bagCheckout.style.pointerEvents = 'none';
        return;
      }
      bagCheckout.removeAttribute('aria-disabled');
      bagCheckout.removeAttribute('tabindex');
      bagCheckout.style.opacity = '';
      bagCheckout.style.pointerEvents = '';
      var html = '';
      items.forEach(function (it) {
        var title = esc(it.product_title);
        var variant = '';
        if (!it.product_has_only_default_variant && it.options_with_values) {
          variant = it.options_with_values.map(function (o) { return esc(o.name) + ' ' + esc(o.value); }).join(' · ');
        }
        // A set is one line at the set price. Name the pieces under it, exactly as the cart page
        // does (templates/cart.liquid .bag-parts) — otherwise the buyer is looking at a single
        // unexplained A$589. `has_components` is the cart API's own flag for a bundle parent, so
        // nothing is drawn for the 60-odd single pieces, and an unmapped set simply gets no list.
        var parts = '';
        if (it.has_components) {
          var pl = bagSets[it.handle];
          if (pl && pl.length) {
            parts = '<ul class="bagd-parts">' + pl.map(function (p) {
              return '<li>' + esc(p) + '</li>';
            }).join('') + '</ul>';
          }
        }
        // The price cell, checkout's pattern and the cart page's (templates/cart.liquid
        // .bag-pair): the original struck through with the fully-net figure beside it when they
        // differ, a single figure when they don't. `linesReconcile` is the guard — the pair is
        // only drawn when these nets actually sum to the cart's own Subtotal; if a payload ever
        // makes them not, the line falls back to the plain original and the ledger below does all
        // of the explaining, which still reconciles. Never a figure assembled here.
        var olp = it.original_line_price;
        var net = lineNet(it);
        var priceCell = (linesReconcile && olp > net)
          ? '<span class="bagd-pr is-pair"><s class="bagd-was">' + money(olp) + '</s>' +
            '<span class="bagd-now">' + money(net) + '</span></span>'
          : '<span class="bagd-pr">' + money(linesReconcile ? net : olp) + '</span>';
        html += '<div class="bagd-line" data-key="' + esc(it.key) + '" data-qty-now="' + it.quantity + '">' +
          '<a class="bagd-thumb" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' +
            (it.image ? '<img src="' + esc(thumbUrl(it.image, 200)) + '" alt="" width="136" height="170" loading="eager" fetchpriority="high" decoding="async">' : '') +
          '</a>' +
          '<div class="bagd-info">' +
            '<div class="bagd-top"><a class="bagd-nm" href="' + esc(it.url) + '">' + title + '</a>' +
              priceCell + '</div>' +
            (variant ? '<p class="bagd-var">' + variant + '</p>' : '') +
            parts +
            // the per-unit note is the ORIGINAL unit price, so it reads against the struck figure
            // above it rather than against the net one (same change §29.5 made on the cart page)
            (it.quantity > 1 ? '<p class="bagd-var">' + money(it.original_price) + ' each</p>' : '') +
            '<div class="bagd-ctl">' +
              '<span class="bagd-qty">' +
                '<button type="button" data-qty="-1" aria-label="Reduce quantity of ' + title + '">&minus;</button>' +
                '<span aria-label="Quantity">' + it.quantity + '</span>' +
                '<button type="button" data-qty="1" aria-label="Increase quantity of ' + title + '">+</button>' +
              '</span>' +
              '<button type="button" class="bagd-rm" data-rm aria-label="Remove ' + title + '">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      });
      bagBody.innerHTML = html;
    };

    var bagFocusables = function () {
      return Array.prototype.filter.call(
        bagEl.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null; }
      );
    };
    var openBag = function (trigger) {
      bagLastFocus = trigger || document.activeElement;
      bagScrim.hidden = false;
      void bagScrim.offsetWidth; // reflow so the unhide can transition (same idiom as the menu)
      bagEl.classList.add('on');
      bagScrim.classList.add('on');
      bagEl.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bag-open');
      bagOpen = true;
      bagCloseBtn.focus();
    };
    var closeBag = function () {
      if (!bagOpen) return;
      bagOpen = false;
      bagEl.classList.remove('on');
      bagScrim.classList.remove('on');
      bagEl.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bag-open');
      var tidy = function () { bagScrim.hidden = true; bagScrim.removeEventListener('transitionend', tidy); };
      bagScrim.addEventListener('transitionend', tidy);
      setTimeout(tidy, 700);
      if (bagLastFocus && bagLastFocus.focus) bagLastFocus.focus();
    };
    var refreshBag = function () {
      return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function (cart) { renderBag(cart); return cart; });
    };
    var changeLine = function (key, qty) {
      showErr('');
      bagEl.classList.add('busy');
      return fetch('/cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'That change did not go through.');
          renderBag(j);
        });
      }).catch(function (err) {
        showErr(err.message || 'That change did not go through — please try again.');
        return refreshBag().catch(function () {});
      }).then(function () {
        bagEl.classList.remove('busy');
        if (!bagEl.contains(document.activeElement)) bagCloseBtn.focus();
      });
    };

    bagBody.addEventListener('click', function (e) {
      var line = e.target.closest('.bagd-line');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var now = parseInt(line.getAttribute('data-qty-now'), 10) || 1;
      var qb = e.target.closest('[data-qty]');
      if (qb) { changeLine(key, Math.max(0, now + parseInt(qb.getAttribute('data-qty'), 10))); return; }
      if (e.target.closest('[data-rm]')) { changeLine(key, 0); }
    });
    bagCloseBtn.addEventListener('click', closeBag);
    bagScrim.addEventListener('click', closeBag);

    /* §join (22 Sep 2026, welcome15) — every "join" link on the page (the announcement bar, the
       drawer's "join Amaurine" line, the cart page's copy of it) points at the footer sign-up
       form, #join in layout/theme.liquid. A plain anchor jump is enough on the page itself, but
       from inside the bag drawer the body scroll is locked (hov.css body.bag-open) and the drawer
       would stay open over the footer — so: close the drawer first, then scroll #join into view
       (its scroll-margin-top clears the sticky header), then put the caret in the field. The
       focus is inside the tap's own handler, so iOS raises the keyboard — wanted here, the
       shopper asked to join; it is NOT the flyout autofocus the capture spec forbids. With JS
       off the anchor still works as an anchor. */
    document.addEventListener('click', function (e) {
      var j = e.target.closest ? e.target.closest('a[href="#join"]') : null;
      if (!j) return;
      var tgt = document.getElementById('join');
      if (!tgt) return;
      e.preventDefault();
      closeBag();
      try { tgt.scrollIntoView({ block: 'start' }); } catch (err) { tgt.scrollIntoView(); }
      var em = document.getElementById('join-email');
      if (em) { try { em.focus({ preventScroll: true }); } catch (err2) {} }
    });
    document.addEventListener('keydown', function (e) {
      if (!bagOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); closeBag(); return; }
      if (e.key !== 'Tab') return;
      var f = bagFocusables();
      if (!f.length) { e.preventDefault(); bagCloseBtn.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!bagEl.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
      else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    // the two PDP forms: AJAX add, then the drawer
    ['pdp-form', 'atc-bar-form'].forEach(function (fid) {
      var f = document.getElementById(fid);
      if (!f) return;
      f.addEventListener('submit', function (e) {
        if (e.defaultPrevented) return; // §size already refused a sizeless post
        var btn = f.querySelector('button[name="add"]');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var body = new URLSearchParams(new FormData(f));
        if (!body.get('id')) return;
        var label = btn.textContent;
        btn.classList.add('is-adding');
        btn.textContent = 'Adding…';
        showErr('');
        fetch('/cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          body: body
        }).then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw { shown: true, message: j.description || j.message || 'That piece could not be added.' };
          });
        }).then(refreshBag).then(function () {
          openBag(btn);
        }).catch(function (err) {
          if (err && err.shown) {
            refreshBag().catch(function () {}).then(function () { openBag(btn); showErr(err.message); });
          } else {
            f.submit(); // network / parse failure: the classic POST to /cart still works
          }
        }).then(function () {
          btn.classList.remove('is-adding');
          btn.textContent = label;
        });
      });
    });

    // sets page add (above) hands over here
    window.hovBag = {
      added: function (trigger) { refreshBag().then(function () { openBag(trigger); }).catch(function () { window.location.href = '/cart'; }); },
      open: function (trigger) { refreshBag().then(function () { openBag(trigger); }).catch(function () { window.location.href = '/cart'; }); }
    };
  }

  // ── mark the active nav item ──
  var path = window.location.pathname;
  document.querySelectorAll('.hnav a, .drawer-nav a').forEach(function (a) {
    if (a.getAttribute('href') !== '/' && path.indexOf(a.getAttribute('href')) === 0) {
      a.setAttribute('aria-current', 'page');
    }
  });

  // ── menu drawer (13 Aug 2026 header rebuild) ──
  // One drawer serves both breakpoints. Scrim click, Close and Esc all dismiss;
  // focus returns to the trigger so keyboard users aren't stranded.
  var menuBtn = document.getElementById('menu-btn');
  var drawer = document.getElementById('site-menu');
  var scrim = document.getElementById('menu-scrim');
  var closeBtn = document.getElementById('menu-close');
  if (menuBtn && drawer && scrim && closeBtn) {
    var setMenu = function (open) {
      if (open) {
        scrim.hidden = false;
        void scrim.offsetWidth; // force reflow so the unhide can transition — no rAF, deterministic
      }
      drawer.classList.toggle('on', open);
      scrim.classList.toggle('on', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('menu-open', open);
      if (!open) {
        var tidy = function () { scrim.hidden = true; scrim.removeEventListener('transitionend', tidy); };
        scrim.addEventListener('transitionend', tidy);
        setTimeout(tidy, 700); // reduced-motion / missed event fallback
      }
    };
    menuBtn.addEventListener('click', function () { setMenu(true); closeBtn.focus(); });
    closeBtn.addEventListener('click', function () { setMenu(false); menuBtn.focus(); });
    scrim.addEventListener('click', function () { setMenu(false); menuBtn.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && menuBtn.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); }
    });
  }

  // ── PDP image zoom (29 Aug 2026) ──
  // Clarity: mobile buyers tap the main product image expecting zoom — confirmed dead clicks —
  // and at these prices the stone and finish must survive inspection. Full-screen viewer, no
  // library. The high-res file (each image's own master width, from the Liquid-emitted JSON in
  // product.liquid) is fetched only once the overlay opens; the already-cached 1400px file
  // shows underneath while it arrives. Pointer events drive pinch / pan / swipe / swipe-down
  // dismiss; keyboard gets Esc, arrows and a focus trap. Everything lives outside the cart
  // forms, so nothing here can touch add-to-bag.
  var zoomEl = document.getElementById('pdp-zoom');
  var zoomDataEl = document.getElementById('pdp-zoom-data');
  var zoomOpenBtn = document.getElementById('pdp-zoom-open');
  if (zoomEl && zoomDataEl && zoomOpenBtn && main) {
    var zImgs = JSON.parse(zoomDataEl.textContent);
    var zStage = document.getElementById('pdp-zoom-stage');
    var zImg = document.getElementById('pdp-zoom-img');
    var zClose = document.getElementById('pdp-zoom-close');
    var zPrev = document.getElementById('pdp-zoom-prev');
    var zNext = document.getElementById('pdp-zoom-next');
    var zCount = document.getElementById('pdp-zoom-count');
    var zReduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    // zX/zY = top-left of the drawn image; fitW/fitH = its size at scale 1 (contained);
    // natScale = the scale at which one image pixel meets one CSS pixel — the pinch ceiling,
    // so a 1600px master simply stops earlier instead of blurring past itself.
    var zIdx = 0, zScale = 1, zX = 0, zY = 0, fitW = 0, fitH = 0, natScale = 1;
    var hiLoaded = {}, lastFocus = null, hinted = false;
    var lastTapT = 0, lastTapX = 0, lastTapY = 0;

    var zApply = function (ex, ey) {
      zImg.style.transform = 'translate(' + (zX + (ex || 0)) + 'px,' + (zY + (ey || 0)) + 'px) scale(' + zScale + ')';
    };
    var zClamp = function () {
      var w = fitW * zScale, h = fitH * zScale;
      var vw = zoomEl.clientWidth, vh = zoomEl.clientHeight;
      zX = w <= vw ? (vw - w) / 2 : Math.min(0, Math.max(vw - w, zX));
      zY = h <= vh ? (vh - h) / 2 : Math.min(0, Math.max(vh - h, zY));
    };
    var zSnap = function () {
      if (!zReduced.matches) {
        zImg.style.transition = 'transform .22s var(--ease)';
        setTimeout(function () { zImg.style.transition = ''; }, 240);
      }
      zApply();
    };
    var zLayout = function () {
      var im = zImgs[zIdx];
      var f = Math.min(zoomEl.clientWidth / im.w, zoomEl.clientHeight / im.h);
      fitW = im.w * f; fitH = im.h * f;
      natScale = Math.max(im.w / fitW, 1.2);
      zImg.style.width = fitW + 'px';
      zImg.style.height = fitH + 'px';
      zScale = 1;
      zClamp(); zApply();
    };
    var zZoomTo = function (px, py, s, animate) {
      s = Math.min(natScale, Math.max(1, s));
      zX = px - (px - zX) * (s / zScale);
      zY = py - (py - zY) * (s / zScale);
      zScale = s;
      zClamp();
      if (animate && !zReduced.matches) {
        zImg.style.transition = 'transform .25s var(--ease)';
        setTimeout(function () { zImg.style.transition = ''; }, 260);
      }
      zApply();
    };
    var zShow = function (i) {
      var n = zImgs.length;
      zIdx = ((i % n) + n) % n;
      var im = zImgs[zIdx];
      zImg.alt = im.alt;
      if (hiLoaded[zIdx]) {
        zImg.src = im.zoom;
      } else {
        zImg.src = im.base; // 1400px, usually already cached by the gallery — instant
        var want = zIdx;
        var hi = new Image();
        hi.onload = function () {
          hiLoaded[want] = true;
          if (zIdx === want && !zoomEl.hidden) zImg.src = im.zoom;
        };
        hi.src = im.zoom;
      }
      zLayout();
      if (zCount) zCount.textContent = (zIdx + 1) + ' / ' + n;
      // warm the neighbours' 1400px files so a swipe lands on something instantly
      if (n > 1) {
        [zIdx + 1, zIdx - 1].forEach(function (j) {
          var k = ((j % n) + n) % n;
          if (!hiLoaded[k]) { (new Image()).src = zImgs[k].base; }
        });
      }
    };
    var openZoom = function (startIdx) {
      lastFocus = document.activeElement;
      var cur = 0;
      if (typeof startIdx === 'number' && startIdx >= 0 && startIdx < zImgs.length) {
        // 12 Sep 2026 (Amaurine p4): the stacked / swiped gallery has one button per image,
        // each carrying its product.images index — open on that image.
        cur = startIdx;
      } else {
        for (var i = 0; i < zImgs.length; i++) {
          if (main.src.indexOf(zImgs[i].base) !== -1) { cur = i; break; }
        }
      }
      zoomEl.hidden = false;
      document.body.classList.add('zoom-open');
      zShow(cur);
      zClose.focus();
      if (!hinted) {
        hinted = true;
        zoomEl.classList.add('hinting');
        setTimeout(function () { zoomEl.classList.remove('hinting'); }, 2600);
      }
    };
    var closeZoom = function () {
      // hand the gallery the image the buyer finished on, via the existing thumb mechanism.
      // 6 Sep 2026: zIdx indexes product.IMAGES (pdp-zoom-data), while the thumb strip now
      // indexes product.MEDIA — on a video-first product the two are offset by the video. The
      // image thumbs alone are the list that matches zIdx; with no video the selector matches
      // every button, exactly as before.
      if (thumbs) {
        var btns = thumbs.querySelectorAll('button:not([data-video])');
        if (btns[zIdx]) {
          var zss = btns[zIdx].getAttribute('data-srcset');
          if (zss) main.setAttribute('srcset', zss); else main.removeAttribute('srcset');
          main.src = btns[zIdx].getAttribute('data-full');
          thumbs.querySelectorAll('button').forEach(function (b) { b.classList.remove('on'); });
          btns[zIdx].classList.add('on');
        }
      } else {
        // 12 Sep 2026 (Amaurine p4): no thumb strip — tell the gallery which image the buyer
        // finished on; the phone track scrolls to it (inline script, templates/product.liquid).
        try { document.dispatchEvent(new CustomEvent('hov:zoomclose', { detail: { idx: zIdx } })); } catch (evErr) {}
      }
      var done = function () {
        zoomEl.hidden = true;
        zoomEl.classList.remove('closing');
        zoomEl.style.opacity = '';
        document.body.classList.remove('zoom-open');
      };
      if (zReduced.matches) { done(); } else {
        zoomEl.classList.add('closing');
        setTimeout(done, 300);
      }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };

    // 12 Sep 2026 (Amaurine p4): every gallery image is a zoom trigger carrying its own index;
    // #pdp-zoom-open is one of them, so it is bound here and not twice. Older markup (one
    // trigger, no index) keeps the src-matching path.
    var zoomBtns = document.querySelectorAll('.gal [data-zoom-idx]');
    if (zoomBtns.length) {
      zoomBtns.forEach(function (zb) {
        zb.addEventListener('click', function () { openZoom(parseInt(zb.getAttribute('data-zoom-idx'), 10)); });
      });
    } else {
      zoomOpenBtn.addEventListener('click', openZoom);
    }
    zClose.addEventListener('click', closeZoom);
    if (zPrev) zPrev.addEventListener('click', function () { zShow(zIdx - 1); });
    if (zNext) zNext.addEventListener('click', function () { zShow(zIdx + 1); });
    window.addEventListener('resize', function () { if (!zoomEl.hidden) zLayout(); });

    document.addEventListener('keydown', function (e) {
      if (zoomEl.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); closeZoom(); }
      else if (e.key === 'ArrowRight' && zImgs.length > 1) { zShow(zIdx + 1); }
      else if (e.key === 'ArrowLeft' && zImgs.length > 1) { zShow(zIdx - 1); }
      else if (e.key === 'Tab') {
        var f = zoomEl.querySelectorAll('button');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (!zoomEl.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    // gestures — one pointer pans (zoomed) / swipes between images or down to dismiss
    // (unzoomed); two pinch; a quick double tap or double click toggles zoom at the point.
    var pts = new Map();
    var gest = null;
    var zDist = function (a, b) { var dx = a.x - b.x, dy = a.y - b.y; return Math.sqrt(dx * dx + dy * dy); };

    zStage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      // capture so moves keep arriving off-stage; guarded — a pointer that has already
      // lifted (or a synthetic event) throws NotFoundError and would kill the gesture
      try { zStage.setPointerCapture(e.pointerId); } catch (capErr) { /* proceed uncaptured */ }
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pts.size === 2) {
        var a = Array.from(pts.values());
        gest = { mode: 'pinch', d0: zDist(a[0], a[1]), mx: (a[0].x + a[1].x) / 2,
                 my: (a[0].y + a[1].y) / 2, s0: zScale, x0: zX, y0: zY };
      } else if (pts.size === 1) {
        gest = { mode: 'press', sx: e.clientX, sy: e.clientY, t: Date.now(),
                 x0: zX, y0: zY, moved: false };
      }
      zStage.classList.add('dragging');
      e.preventDefault();
    });
    zStage.addEventListener('pointermove', function (e) {
      if (!pts.has(e.pointerId) || !gest) return;
      var p = pts.get(e.pointerId);
      p.x = e.clientX; p.y = e.clientY;
      if (gest.mode === 'pinch') {
        if (pts.size < 2) return;
        var a = Array.from(pts.values());
        var s = Math.min(natScale, Math.max(1, gest.s0 * (zDist(a[0], a[1]) / gest.d0)));
        var eff = s / gest.s0;
        zX = (a[0].x + a[1].x) / 2 - (gest.mx - gest.x0) * eff;
        zY = (a[0].y + a[1].y) / 2 - (gest.my - gest.y0) * eff;
        zScale = s;
        zClamp(); zApply();
        return;
      }
      var dx = e.clientX - gest.sx, dy = e.clientY - gest.sy;
      if (!gest.moved && Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      gest.moved = true;
      if (gest.mode === 'press') {
        if (zScale > 1.01) { gest.mode = 'pan'; }
        else if (Math.abs(dy) > Math.abs(dx) && dy > 0) { gest.mode = 'dismiss'; }
        else if (zImgs.length > 1 && Math.abs(dx) > Math.abs(dy)) { gest.mode = 'swipe'; }
        else { gest.mode = 'pan'; }
      }
      if (gest.mode === 'pan') { zX = gest.x0 + dx; zY = gest.y0 + dy; zClamp(); zApply(); }
      else if (gest.mode === 'swipe') { zApply(dx, 0); }
      else if (gest.mode === 'dismiss') {
        zoomEl.style.opacity = Math.max(0.25, 1 - dy / 600);
        zApply(0, Math.max(0, dy));
      }
    });
    var zEnd = function (e) {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (gest && gest.mode === 'pinch') {
        if (pts.size < 2) gest = null; // lone leftover finger: press again to pan
        if (!pts.size) zStage.classList.remove('dragging');
        return;
      }
      if (!gest) { if (!pts.size) zStage.classList.remove('dragging'); return; }
      var g = gest; gest = null;
      zStage.classList.remove('dragging');
      var dx = e.clientX - g.sx, dy = e.clientY - g.sy;
      var dt = Date.now() - g.t;
      if (g.mode === 'press' && !g.moved) {
        var now = Date.now();
        if (now - lastTapT < 350 && Math.abs(e.clientX - lastTapX) < 40 && Math.abs(e.clientY - lastTapY) < 40) {
          lastTapT = 0;
          zZoomTo(e.clientX, e.clientY, zScale > 1.01 ? 1 : Math.min(2.6, natScale), true);
        } else { lastTapT = now; lastTapX = e.clientX; lastTapY = e.clientY; }
        return;
      }
      if (g.mode === 'swipe') {
        if (Math.abs(dx) > 60 || (Math.abs(dx) > 30 && dt < 250)) { zShow(zIdx + (dx < 0 ? 1 : -1)); }
        else { zSnap(); }
      } else if (g.mode === 'dismiss') {
        zoomEl.style.opacity = '';
        if (dy > 110 || (dy > 60 && dt < 250)) { closeZoom(); } else { zSnap(); }
      }
    };
    zStage.addEventListener('pointerup', zEnd);
    zStage.addEventListener('pointercancel', zEnd);
    zStage.addEventListener('wheel', function (e) {
      e.preventDefault();
      zZoomTo(e.clientX, e.clientY, zScale * Math.exp(-e.deltaY * 0.0022), false);
    }, { passive: false });
    // iOS Safari page-pinch belt-and-braces on top of touch-action:none
    ['gesturestart', 'gesturechange'].forEach(function (t) {
      document.addEventListener(t, function (e) { if (!zoomEl.hidden) e.preventDefault(); });
    });
  }

  // ── Collection filter & sort (3 Sep 2026, Search & Discovery) — templates/collection.liquid ──
  // The form is a plain GET and works with no script. Here: one dropdown open at a time on
  // desktop, outside-click and Esc close them, checkbox and sort changes submit on their own
  // at desktop widths (mobile keeps its Apply button so a run of ticks doesn't reload the
  // page each time), and the whole row starts folded on mobile.
  var refine = document.getElementById('refine');
  var refineForm = document.getElementById('refine-form');
  if (refine && refineForm) {
    var narrow = window.matchMedia('(max-width:900px)');
    if (narrow.matches) refine.removeAttribute('open');
    refine.classList.add('js');
    var groups = Array.prototype.slice.call(refineForm.querySelectorAll('.rf-group'));
    var closeGroups = function (except) {
      groups.forEach(function (g) { if (g !== except) g.removeAttribute('open'); });
    };
    groups.forEach(function (g) {
      g.addEventListener('toggle', function () { if (g.open && !narrow.matches) closeGroups(g); });
    });
    document.addEventListener('click', function (e) {
      if (narrow.matches || refineForm.contains(e.target)) return;
      closeGroups(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeGroups(null);
    });
    refineForm.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'sort_by' || (t.type === 'checkbox' && !narrow.matches)) refineForm.submit();
    });
  }

  /* §reviews (5 Sep 2026) — the PDP Reviews row (templates/product.liquid) holds the Judge.me
     review widget inside a <details> that is closed at load. Judge.me sets its widgets up whether
     or not they are on screen (verified on the live PDP: the hidden div comes back carrying
     jdgm--done-setup-widget), so there is nothing to re-initialise on expand and this deliberately
     does not try — jdgm.initializeWidgets() throws part-way through on this install, because the
     media-gallery module is only fetched for a widget that needs it.

     What DOES need a nudge is the app's lazy media: review photos and timestamps are decorated on
     scroll, and a panel that was display:none at load never fired one. Dispatching a scroll on
     first open is enough, and it is inert when the panel holds the house's empty state. */
  var revDetails = document.getElementById('pdp-rev');
  if (revDetails) {
    var revNudged = false;
    revDetails.addEventListener('toggle', function () {
      if (!revDetails.open || revNudged) return;
      revNudged = true;
      if (!revDetails.querySelector('.jdgm-review-widget')) return;
      try {
        window.dispatchEvent(new Event('scroll'));
        if (window.jdgm && typeof window.jdgm.customizeReviews === 'function') {
          window.jdgm.customizeReviews();
        }
      } catch (err) { /* an app-side failure must never break the accordion */ }
    });
  }

  /* §badge-jump (5 Sep 2026 evening) — the star badge under the PDP title is an anchor to
     #pdp-reviews. Left alone the browser would jump to a CLOSED <details>, which looks like a
     dead link. So: open the row first, then scroll. Setting .open fires the native toggle event,
     so §reviews above still gets its one lazy-media nudge with no extra wiring here.

     Written against the document rather than the anchor so it is inert when no badge is printed
     (products with no reviews print nothing at all), and it degrades to the plain anchor if the
     row is missing for any reason. */
  document.addEventListener('click', function (e) {
    var jump = e.target.closest ? e.target.closest('[data-hov-revjump]') : null;
    if (!jump) return;
    var row = document.getElementById('pdp-reviews');
    var det = document.getElementById('pdp-rev');
    if (!row) return;
    e.preventDefault();
    if (det && !det.open) det.open = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = window.pageYOffset;
    row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    /* Smooth scrolling is not honoured everywhere (verified 5 Sep 2026: in an automated Chrome
       reporting prefers-reduced-motion:no-preference, `behavior:'smooth'` silently no-ops and the
       page never moves). A dead link is worse than an unanimated one, so if nothing has moved
       after the animation should have started, jump. */
    if (!reduce) {
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - from) < 2) row.scrollIntoView({ block: 'start' });
      }, 400);
    }
    if (det) {
      var sum = det.querySelector('summary');
      if (sum) { sum.setAttribute('tabindex', '-1'); sum.focus({ preventScroll: true }); }
    }
  });

  /* §trust-seg (22 Sep 2026, pdp-fixes-2026-09-22 change 1b) — the delivery line under Add to
     bag is printed as one anchor per " · " segment (templates/product.liquid, #pdp-delivery).
     Clarity 20–22 Sep: the only tap on that line in two days was a dead tap. A tap now opens the
     Questions item that answers the segment and scrolls to it, the same way §badge-jump above
     opens the Reviews row. Matching is by words, against each item's question AND answer text,
     because the FAQ set differs per product (generated by snippets/pdp-faq.liquid, or replaced by
     the custom.faq_json metafield):
       crafted to order / shipping / business days / tracked  → the "delivered" item
       returns                                               → the "suit" item (thirty days)
       warranty                                              → the first answer naming a warranty,
                                                                else the returns item
     The other Questions items close (they share a `name`, so browsers that honour it do this
     themselves; the loop covers the rest). With no match, or no JS, the anchor's own href lands
     on #pdp-faq. Written against the document so it costs nothing on a page without the line. */
  document.addEventListener('click', function (e) {
    var seg = e.target.closest ? e.target.closest('[data-trust-seg]') : null;
    if (!seg) return;
    var faq = document.getElementById('pdp-faq');
    if (!faq) return;
    var items = Array.prototype.slice.call(faq.querySelectorAll('details.faq-item'));
    if (!items.length) return;
    var label = (seg.textContent || '').toLowerCase();
    /* two passes: the QUESTION first (so "How is it delivered?" beats an answer that merely
       mentions shipping), then question + answer; `answerOnly` skips the first pass */
    var find = function (re, answerOnly) {
      var i, s, a, txt;
      if (!answerOnly) {
        for (i = 0; i < items.length; i++) {
          s = items[i].querySelector('summary');
          if (s && re.test((s.textContent || '').toLowerCase())) return items[i];
        }
      }
      for (i = 0; i < items.length; i++) {
        s = items[i].querySelector('summary');
        a = items[i].querySelector('.faq-a');
        txt = ((answerOnly ? '' : (s ? s.textContent : '')) + ' ' + (a ? a.textContent : '')).toLowerCase();
        if (re.test(txt)) return items[i];
      }
      return null;
    };
    var target = null;
    /* water-safe (24 Sep 2026): the Éternelle strip's first segment opens the care question,
       whose answer carries "Rinse after the pool or the sea." */
    if (/water|swim|shower/.test(label)) {
      target = find(/look after/) || find(/water-safe/, true);
    } else if (/warranty|guarantee/.test(label)) {
      target = find(/warranty|guarantee/, true) || find(/doesn.t suit|return/);
    } else if (/return|exchange|refund/.test(label)) {
      target = find(/doesn.t suit|thirty days|30 days|return/);
    } else if (/crafted|made to order|shipping|business days|tracked|deliver|dispatch|arrive/.test(label)) {
      target = find(/delivered\?|deliver|shipping/);
    }
    if (!target) target = find(/deliver|shipping/) || items[0];
    e.preventDefault();
    items.forEach(function (d) { if (d !== target && d.open) d.open = false; });
    if (!target.open) target.open = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var from = window.pageYOffset;
    /* land the OPEN item just under the sticky header (the header is ~55–82px on a phone PDP) */
    var top = target.getBoundingClientRect().top + window.pageYOffset - 72;
    try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (err) { window.scrollTo(0, top); }
    if (!reduce) {
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - from) < 2) window.scrollTo(0, top);
      }, 400);
    }
    var sum2 = target.querySelector('summary');
    if (sum2) { sum2.setAttribute('tabindex', '-1'); try { sum2.focus({ preventScroll: true }); } catch (err2) {} }
  });

  /* §bag-checkout (22 Sep 2026, pdp-fixes-2026-09-22 change 4) — the bag drawer's Checkout is a
     plain link. Until later on 22 Sep it went through /discount/<code>?redirect=/checkout (now a
     direct /checkout — the welcome code is retired, welcome15-2026-09-22), and that navigation was
     FOUR hops (302 → /checkout 302 → shop.app 302 → /checkouts/cn/… 200) before the first byte:
     1.0–1.7 s on emulated 4G (checkout_probe.py, 22 Sep), longer inside an in-app browser on a
     real network. Clarity (CONVERSION-ROUND2 §10.4 row 19): a shopper tapped Checkout, saw
     nothing for 5 s, and tapped again. The probe could not make a tap on the button fail — every
     tap navigated — so the fix is feedback, not routing: on the first tap the button reads
     "Opening checkout…" with a spinner (hov.css §pdp-under-button) and further taps in the next
     8 s are swallowed (the navigation is already in flight; a second GET would only restart the
     chain). pageshow with `persisted` (bfcache: the shopper came back with the browser's Back)
     and the 8 s timer both restore the button. Nothing here changes the href or the route. */
  var bagGo = document.getElementById('bagd-checkout');
  if (bagGo) {
    var bagGoLabel = bagGo.textContent;
    var bagGoT = null;
    var bagGoReset = function () {
      window.clearTimeout(bagGoT);
      bagGo.classList.remove('is-going');
      bagGo.removeAttribute('aria-busy');
      bagGo.textContent = bagGoLabel;
    };
    bagGo.addEventListener('click', function (e) {
      if (bagGo.getAttribute('aria-disabled') === 'true') return; // empty bag: the drawer already disables it
      if (bagGo.classList.contains('is-going')) { e.preventDefault(); return; } // already on its way
      bagGo.classList.add('is-going');
      bagGo.setAttribute('aria-busy', 'true');
      bagGo.textContent = 'Opening checkout…';
      bagGoT = window.setTimeout(bagGoReset, 8000);
    });
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) bagGoReset(); });
  }

  /* §collintro (5 Sep 2026 evening) — the collection intro is clamped to two lines below 768px
     (hov.css) so the product grid clears the first screen on the ad landing pages. This is the
     opener. Everything visual is CSS: the button only flips `.is-open` and its own aria-expanded,
     so with JS off the two lines stand, the full copy is still in the DOM, and nothing is broken.

     The clamp is media-query-scoped, so no work is needed on resize — a desktop that narrows
     picks up the collapsed state, and the button reappears already labelled correctly. */
  var introBtn = document.querySelector('.collintro-more');
  var intro = document.getElementById('coll-intro');
  if (introBtn && intro) {
    var introLab = introBtn.querySelector('span');
    introBtn.addEventListener('click', function () {
      var open = intro.classList.toggle('is-open');
      introBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (introLab) introLab.textContent = open ? introLab.dataset.less : introLab.dataset.more;
    });
  }

  /* §promo (5 Sep 2026) — client-side deadline gate for the announcement bar and the PDP line.
     The Liquid gate in snippets/hov-promo.liquid stops the markup being GENERATED after the
     deadline, but Liquid's `now` is evaluated when a page is rendered and Shopify edge-caches
     storefront pages: a page built at 08:59 on Monday can still be served at 09:30 with the bar
     baked into it. This removes any such copy on the client, so the promotion ends on time
     whether or not anyone pushes the theme.

     No deadline lives here. Every gated element carries its own `data-promo-until` (epoch
     seconds), written by the snippet, so the constant has exactly one home in the theme and
     this stays generic for whatever the next promotion is. An element with a missing or
     unparseable deadline is removed rather than left standing — a promotion that quietly
     stops being announced is recoverable; one that outlives its own end date is not. */
  var promoEls = document.querySelectorAll('[data-promo-until]');
  if (promoEls.length) {
    var promoTimer = null;
    var promoSweep = function () {
      var now = Date.now() / 1000, live = 0;
      promoEls.forEach(function (el) {
        var until = parseInt(el.getAttribute('data-promo-until'), 10);
        if (!until || now >= until) { if (el.parentNode) el.remove(); } else { live++; }
      });
      if (!live && promoTimer) { clearInterval(promoTimer); promoTimer = null; }
      return live;
    };
    if (promoSweep()) {
      // the two moments a page can outlive its deadline without a reload: a tab left open,
      // and a tab woken from the background
      promoTimer = setInterval(promoSweep, 60000);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) promoSweep();
      });
    }
  }

  /* §promodal (5 Sep 2026) — the promotion dialog. Owner spec: it opens by itself, it is
     unmissable, and the ONLY way out is the small × in the top-right of the card. Escape is
     kept as well, for keyboard and screen-reader users; a modal with no key escape is a trap.
     The backdrop is deliberately inert — clicking it does nothing, by request.

     DELIBERATELY AFTER §promo ABOVE. The sweep has already run by the time this executes, so an
     expired dialog is no longer in the DOM and getElementById finds nothing. That is gate one.
     Gate two is the explicit deadline check in openPromodal, for the case where the sweep has
     not yet noticed. Gate three is the Liquid gate, which stops the markup existing at all.
     No deadline is written here: the epoch is read off the element, exactly as §promo does, so
     `promo_ends` in snippets/hov-promo.liquid stays the theme's one and only promotion date.

     ONCE PER BROWSING SESSION, via sessionStorage (NOT localStorage — a returning visitor next
     week should see the next promotion, and the flag should die with the tab). Every storage
     call is wrapped: Safari private mode and locked-down browsers throw on both read and write.
     A read that throws FAILS OPEN — the dialog shows. Showing a promotion twice to someone with
     storage disabled is a smaller failure than never showing it at all. */
  /* 7 Sep 2026 (owner decision 2A, critique blocker 1). Three changes to the 5 Sep spec:
       · AD AND IN-APP TRAFFIC NEVER SEES IT. §adtraffic above answers that question; the
         element is removed outright rather than left hidden, so nothing can open it later and
         §promo has nothing to sweep. Four in five sessions arrive inside the Facebook or
         Instagram webview, whose session dies on every app switch — the "seen once" flag could
         not hold, so the same buyer met the dialogue again and again on the way to a product.
       · THE BACKDROP CLOSES IT. The 5 Sep "deliberately inert" spec is superseded: an inert
         backdrop with a 40px × in the corner is a dead tap on a phone.
       · THE CTA IS "Continue" AND STAYS ON THE PAGE (a <button> now, in hov-promo.liquid). It
         used to navigate to /collections/bestsellers — away from the very piece the ad had just
         sold them. The close path is otherwise unchanged, including the once-per-session flag. */
  var pmd = document.getElementById('promodal');
  if (pmd && hovAdTraffic()) { pmd.remove(); pmd = null; }
  if (pmd) {
    // 10 Sep 2026: the Complete the Look dialog carries no deadline — a missing or unparsable
    // attribute now means "no deadline" (0), not "never open". Dated dialogs still expire.
    var pmdUntil = parseInt(pmd.getAttribute('data-promo-until'), 10) || 0;
    var pmdX = document.getElementById('promodal-x');
    var pmdCta = document.getElementById('promodal-cta');
    var pmdAlt = document.getElementById('promodal-alt');
    var pmdCard = pmd.querySelector('.promodal-card');
    var pmdOpen = false, pmdLast = null, pmdEndTimer = null;

    var pmdSeen = function () {
      try { return window.sessionStorage.getItem('hov_ctl_seen') === '1'; }
      catch (e) { return false; } // storage unavailable → show
    };
    var pmdMarkSeen = function () {
      try { window.sessionStorage.setItem('hov_ctl_seen', '1'); } catch (e) {}
    };

    // same shape as the bag drawer's trap, same filter: no tabindex="-1", nothing invisible
    var pmdFocusables = function () {
      return Array.prototype.filter.call(
        pmd.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getAttribute('tabindex') !== '-1' && el.offsetParent !== null; }
      );
    };

    var closePromodal = function () {
      if (!pmdOpen) return;
      pmdOpen = false;
      if (pmdEndTimer) { clearTimeout(pmdEndTimer); pmdEndTimer = null; }
      pmd.classList.remove('on');
      document.body.classList.remove('promodal-open');
      pmdMarkSeen();
      // re-hide after the fade so the element stops existing for the accessibility tree; the
      // timeout is the backstop for a transitionend that never arrives (reduced motion, a
      // backgrounded tab). Same idiom as the bag scrim.
      var tidy = function () { pmd.hidden = true; pmd.removeEventListener('transitionend', tidy); };
      pmd.addEventListener('transitionend', tidy);
      setTimeout(tidy, 700);
      if (pmdLast && pmdLast.focus) pmdLast.focus();
    };

    var openPromodal = function () {
      if (pmdOpen) return;
      if (pmdUntil && Date.now() / 1000 >= pmdUntil) return; // dated and expired: never open
      if (!document.body.contains(pmd)) return;               // §promo already swept it
      if (pmdSeen()) return;
      pmdLast = document.activeElement;
      // 10 Sep 2026: the dialog's photograph is lazy in the markup so visitors who have already
      // seen it never fetch it; the moment it is actually going to open, make it eager.
      var pmdImg = pmd.querySelector('img[loading="lazy"]');
      if (pmdImg) pmdImg.loading = 'eager';
      pmd.hidden = false;
      void pmd.offsetWidth; // reflow so the unhide can transition
      pmd.classList.add('on');
      document.body.classList.add('promodal-open');
      pmdOpen = true;
      /* FOCUS THE DIALOG, NOT THE ×  (5 Sep 2026)
         Focus still moves into the dialog on open — the trap and the restore-on-close below are
         unchanged — but it lands on the card rather than on the close button. Focusing the button
         painted the gold ring on first sight of the modal for everyone, mouse users included:
         Chrome treats a programmatic .focus() on a page the visitor has not yet interacted with
         as keyboard-initiated, so :focus-visible matched. (The rule in hov.css has always been
         :focus-visible — the ring was never on plain :focus, so no CSS change could have stopped
         it.) A tabindex="-1" container draws no ring under any browser's heuristic, and it is
         also the better screen-reader result: the dialog announces its own name via
         aria-labelledby instead of announcing "Close, button". The first Tab moves to the ×,
         which then rings properly because that focus IS keyboard-initiated. */
      if (pmdCard) pmdCard.focus();
      else if (pmdX) pmdX.focus();
      // If the deadline falls while it is open, §promo's sweep would rip the element out from
      // under an open dialog and leave the body scroll-locked with nothing to close. Close it
      // properly at the deadline instead. Guarded against the 32-bit setTimeout ceiling.
      var ms = pmdUntil * 1000 - Date.now();
      if (ms > 0 && ms < 2147483000) pmdEndTimer = setTimeout(closePromodal, ms);
    };

    if (pmdX) pmdX.addEventListener('click', closePromodal);
    // the CTA navigates; closing first releases the scroll lock and marks the session seen, so
    // a browser Back into the bfcache does not land on a live dialog
    // the CTA is now a plain "Continue" button: it closes the dialogue and leaves the buyer
    // exactly where they were. Nothing navigates.
    // 10 Sep 2026: the CTA is a "Shop gold" LINK off the gold pages and a "Continue" button on
    // them; closing first marks the session seen and releases the scroll lock, and a link then
    // navigates on its own. "Continue browsing" (#promodal-alt) just closes.
    if (pmdCta) pmdCta.addEventListener('click', function () { closePromodal(); });
    if (pmdAlt) pmdAlt.addEventListener('click', function () { closePromodal(); });
    // Backdrop click closes (7 Sep 2026, owner decision 2A — supersedes the 5 Sep inert spec).
    // `e.target === pmd` only: .promodal is the backdrop itself and the card is its child, so a
    // click anywhere inside the card, or a drag that ends outside it, never closes.
    pmd.addEventListener('click', function (e) { if (e.target === pmd) closePromodal(); });

    document.addEventListener('keydown', function (e) {
      if (!pmdOpen) return;
      if (e.key === 'Escape') { e.preventDefault(); closePromodal(); return; }
      if (e.key !== 'Tab') return;
      var f = pmdFocusables();
      if (!f.length) { e.preventDefault(); if (pmdCard) pmdCard.focus(); else if (pmdX) pmdX.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      var act = document.activeElement;
      /* The card is now the open-state focus holder, and it is deliberately NOT in the cycle
         (tabindex="-1", excluded by pmdFocusables). So it is handled with the outside-the-dialog
         case: Tab enters at the first control, Shift+Tab enters at the last. Without this the
         very first Shift+Tab would have walked straight out of an aria-modal dialog. */
      if (!pmd.contains(act) || act === pmdCard) { e.preventDefault(); (e.shiftKey ? last : first).focus(); }
      else if (e.shiftKey && act === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && act === last) { e.preventDefault(); first.focus(); }
    });

    // a bfcache restore replays the DOM as it was at unload — mid-close, that is a hidden-but-
    // present overlay and possibly a body still carrying the lock class. Tidy both.
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted || pmdOpen) return;
      pmd.hidden = true;
      document.body.classList.remove('promodal-open');
    });

    /* Open ~600ms after DOMContentLoaded. hov.js is the last script before </body>, so the DOM
       is already parsed and readyState is usually 'interactive' — but the delay is measured
       from DOMContentLoaded either way, which puts the paint of the dialog behind the LCP hero
       rather than in front of it. */
    if (!pmdSeen()) {
      var pmdArm = function () { window.setTimeout(openPromodal, 600); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pmdArm);
      else pmdArm();
    }
  }

})();

/* §loadmore (10 Sep 2026) — collection pages that run past one page. Shopify caps a page at 50
   products, and the Gold range is now larger than that, so the pieces on page 2 (the Portique
   Cuff among them) were invisible to anyone who did not click a page number. The template
   keeps its numbered links for crawlers and for no-JS; here they are hidden and a single
   "Show all pieces" button fetches the next page, lifts its cards into the same .grid, and
   repeats until there is no next page. Cards are plain markup with native lazy images and no
   script hooks, so appended cards need no re-initialisation. Any failure puts the numbered
   links back. No cart or analytics side effects: it is a page fetch. */
(function () {
  var nav = document.querySelector('.pagenav[data-loadmore]');
  if (!nav) return;
  var btn = document.getElementById('grid-more');
  var grid = document.querySelector('.grid');
  var links = nav.querySelector('.pagenav-links');
  if (!btn || !grid || !nav.getAttribute('data-next')) return;
  if (links) links.hidden = true;
  /* 10 Sep 2026 (owner, same evening): no button after all. Page 1 of Gold ended on a single
     orphan card and read as the end of the range — it fooled David himself. The remaining
     pages are now fetched automatically as soon as the page is interactive, so the grid is
     always complete and there is never a "page 1". The button stays in the markup, hidden,
     purely as the failure fallback alongside the numbered links. */
  btn.hidden = true;
  var label = btn.textContent, busy = false;
  var fail = function () {
    busy = false;
    btn.hidden = true;
    if (links) links.hidden = false;
  };
  var more = function () {
    var next = nav.getAttribute('data-next');
    if (!next || busy) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Loading\u2026';
    fetch(next, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var g = doc.querySelector('.grid');
        if (!g) throw new Error('no grid');
        var frag = document.createDocumentFragment();
        Array.prototype.forEach.call(g.children, function (c) { frag.appendChild(document.importNode(c, true)); });
        grid.appendChild(frag);
        var nn = doc.querySelector('.pagenav[data-loadmore]');
        var nxt = nn ? nn.getAttribute('data-next') : null;
        busy = false;
        if (nxt) {
          nav.setAttribute('data-next', nxt);
          btn.disabled = false;
          btn.textContent = label;
          more(); // keep going until the range is complete
        } else {
          nav.remove();
        }
      })
      .catch(fail);
  };
  btn.addEventListener('click', more);
  var auto = function () { if (window.requestIdleCallback) window.requestIdleCallback(more, { timeout: 1500 }); else window.setTimeout(more, 200); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();
})();
/* §loc (10 Sep 2026, NZ launch) — the country/currency <select> in the header and footer is a
   Shopify localization form; changing it posts country_code and the page reloads priced in that
   market's currency. No JS-off fallback is needed: without JS the select simply does nothing and
   the shop stays in the visitor's detected market. */
(function () {
  document.querySelectorAll('select[data-loc]').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form) s.form.submit(); });
  });
})();